import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './SelectedGoal7.css';

const SelectedGoal = (props) => {
    // Función helper para normalizar fechas
    const normalizeDate = (dateValue) => {
        if (!dateValue) return null;
        if (dateValue === '' || dateValue === 'null' || dateValue === 'undefined') return null;
        if (dateValue instanceof Date) {
            return !isNaN(dateValue.getTime()) ? dateValue : null;
        }
        const parsed = new Date(dateValue);
        return !isNaN(parsed.getTime()) ? parsed : null;
    };

    const SelectedGoal = (
        <section 
            className="ActionSelected Action__content"
            style={{
                backgroundColor: props.goal.color,
            }}
        >
            <section
                className="SelectActionNumber__content  SelectActionNumber "
            >
                {props.GoalIndex + 1}
            </section>
            <section className="SelectedGoal__Content "  >
                <div className=" GoalSelectedAction">
                    {props.goal.text}
                    {props.mobile && (
                        <p>
                            <DatePicker
                                dateFormat="MMMM dd, yyyy"
                                selected={normalizeDate(props.goal.completedByDate)}
                                withPortal 
                                className="datePickerGoal7"
                                placeholderText="Complete by: mm/dd/yyyy"
                                minDate={new Date()}
                                disabled="disabled"
                            />
                        </p>
                    )}
                </div>
            </section>
            {!props.mobile && ( <section
                className="SelectActionNumber__content"
            >
                <DatePicker
                    dateFormat="MMMM dd, yyyy"
                    selected={normalizeDate(props.goal.completedByDate)}
                    withPortal 
                    className="datePickerGoal7"
                    placeholderText="Complete by: mm/dd/yyyy"
                    minDate={new Date()}
                    disabled="disabled"
                />
            </section>)}
        </section>
    );
    return SelectedGoal;
};
export default SelectedGoal;
